import { EMOJI_MAP } from '../components/EmojiPicker/data';
import { useState, useEffect, useCallback } from 'react';
import { message } from 'antd';

// Keep your existing static items, but they'll be overridden by backend data in the selector
export const THUMBNAIL_ITEM_META = {
  thumbnail: {
    length: 15,
    type: 'thumbnail',
    items: [
      { key: 'Color & Gradient', src: '/img/thumbnails/solid_red.png' },
      { key: 'Color & Gradient', src: '/img/thumbnails/solid_yellow.png' },
      { key: 'Color & Gradient', src: '/img/thumbnails/solid_blue.png' },
      { key: 'Color & Gradient', src: '/img/thumbnails/solid_beige.png' },
      { key: 'Color & Gradient', src: '/img/thumbnails/gradients_8.png' },
      { key: 'Color & Gradient', src: '/img/thumbnails/gradients_4.png' },
      { key: 'Color & Gradient', src: '/img/thumbnails/gradients_2.png' },
      { key: 'Color & Gradient', src: '/img/thumbnails/gradients_11.jpg' },
      { key: 'Color & Gradient', src: '/img/thumbnails/gradients_10.jpg' },
      { key: 'Color & Gradient', src: '/img/thumbnails/gradients_5.png' },
      { key: 'Color & Gradient', src: '/img/thumbnails/gradients_3.png' },
      { key: 'Patterns', src: '/img/thumbnails/webb1.jpg' },
      { key: 'Patterns', src: '/img/thumbnails/webb2.jpg' },
      { key: 'Patterns', src: '/img/thumbnails/webb3.jpg' },
      { key: 'Patterns', src: '/img/thumbnails/webb4.jpg' },
    ],
  },
  icon: {
    length: Object.keys(EMOJI_MAP).length,
    type: 'icon',
    items: [],
  },
};

export const useThumbnail = ({ dfltValue, onChange, itemType = 'thumbnail', autoSelectRandom = true }) => {
  const [open, setOpen] = useState(false);
  const [value, setValue] = useState(dfltValue || null);

  useEffect(() => {
    setValue(dfltValue);
  }, [dfltValue]);

  const changeValue = useCallback(
    (param) => {
      let preValue = '';
      setValue((prev) => {
        preValue = prev;
        return param?.value;
      });
      onChange?.(param, () => {
        message.error('Unable to save page icon.');
        setValue(preValue);
      });
    },
    [setValue, onChange]
  );

  const handleClick = useCallback(() => {
    setOpen((prev) => !prev);
    if (!value && autoSelectRandom) {
      const len = THUMBNAIL_ITEM_META[itemType]?.length || 0;
      const randomIndex = Math.floor(Math.random() * len);
      let randomValue = null;
      if (itemType === 'icon') randomValue = Object.keys(EMOJI_MAP)[randomIndex] || null;
      else randomValue = THUMBNAIL_ITEM_META[itemType]?.items[randomIndex]?.src || null;
      changeValue({ type: itemType, value: randomValue });
    }
  }, [value, onChange, changeValue, itemType]);

  const handleSelect = useCallback(
    (param) => {
      changeValue(param);
      setOpen(false);
    },
    [changeValue, setOpen]
  );

  const handleRemove = useCallback(() => {
    changeValue({ type: itemType, value: null });
    setOpen(false);
  }, [changeValue, itemType]);

  const handleClose = useCallback(() => setOpen(false), [setOpen]);

  const getValue = useCallback(() => {
    if (itemType === 'icon') return EMOJI_MAP[value];
    else {
      const item = THUMBNAIL_ITEM_META[itemType]?.items.find((item) => item?.src === value);
      return item || null;
    }
  }, [value, itemType]);

  return { value, open, handleSelect, handleClick, getValue, handleClose, handleRemove };
};

export default useThumbnail;
